<template>
  <q-layout id="page" class="site">
    <site-header />

    <q-page-container id="content" class="site-content">
      <router-view />
    </q-page-container>

    <site-footer />
  </q-layout>
</template>

<script lang="ts">
import { defineComponent, ref, defineAsyncComponent } from 'vue';
import SiteHeader from 'components/Base/SiteHeader.vue';

export default defineComponent({
  name: 'MainLayout',

  components: {
    SiteFooter: defineAsyncComponent(() => import('components/Base/SiteFooter.vue')),
    SiteHeader,
  },

  setup() {
    const leftDrawerOpen = ref(false);

    return {
      leftDrawerOpen,
      toggleLeftDrawer() {
        leftDrawerOpen.value = !leftDrawerOpen.value;
      },
    };
  },
});
</script>

<style>
#content {
  padding-bottom: 5rem;
}
</style>
